import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";
import { CommunityCareService } from "./CommunityCareService";
import { IFormSubmitResponse } from "./Models/FormSubmitResponse";

export class CommunityCareForm extends Component {
	dxeBearerToken: string | undefined;
	form: HTMLFormElement;

	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		if (this._element.tagName !== "FORM") {
			throw new Error(`Non-form element passed in, element: ${this._element}`);
		}

		this.form = this._element as HTMLFormElement;
		// tslint:disable-next-line
		this.initialize();
	}

	private async initialize(): Promise<void> {
		this.applyValidationRules(this.form);
		this.form.addEventListener("submit", e => this.handleSubmission(e));
	}

	private applyValidationRules(form: HTMLFormElement): void {
		const messages = this._element.dataset;
		const errorClass = "hasError";

		$(form).validate({
			errorClass: "hasError",
			errorPlacement: (error, element) => {
				error.appendTo(element.next(".error-container"));
			},
			highlight: element => {
				$(element).parent().addClass(errorClass);
			},
			messages: {
				address: {
					required: messages.addressMsg ?? ""
				},
				email: messages.customEmailMsg ?? "",
				formmessage: {
					required: messages.customFormMsg ?? ""
				},
				fullname: {
					required: messages.customNameMsg ?? ""
				},
				organizationname: {
					required: messages.customOrgnameMsg ?? ""
				}
			},
			rules: {
				address: {
					required: true
				},
				email: {
					email: true,
					required: true
				},
				formmessage: {
					required: true
				},
				fullname: {
					required: true
				},
				organizationname: {
					required: true
				}
			},
			unhighlight: element => {
				$(element).parent().removeClass(errorClass);
			}
		});
	}

	private async handleSubmission(e: Event): Promise<void> {
		e.preventDefault();
		this.toggleSubmitBtn(false);
		const formHasErrors = !this.validate();
		if (formHasErrors) {
			this.toggleSubmitBtn(true);

			return;
		}

		await this.submitForm();
	}

	private async submitForm(addressId?: string): Promise<void> {
		const {
			submissionEndpoint,
			recaptchaEndpoint,
			redirectSuccess,
			redirectError,
			formDatasourceId,
			emailToSubmit = ""
		} = this._element.dataset;
		const payload = $(this.form).serializeArray();
		const dictionary = Object.assign(
			{},
			...payload.map(x => ({ [x.name]: x.value }))
		);

		if (!submissionEndpoint) {
			throw new Error(
				`Submission endpoint value not found for ${submissionEndpoint}`
			);
		}
		this.toggleRecaptchaErr(false);
		this.toggleSubmitBtn(false);
		const promise = $.ajax({
			contentType: "application/json",
			data: JSON.stringify({
				recaptchaGuid: dictionary["g-recaptcha-response"]
			}),
			type: "POST",
			url: recaptchaEndpoint
		});

		const result = await Promise.resolve(promise);

		if (!result) {
			// TODO: Need to highlight recaptcha error
			console.warn("Recaptcha failed.");
			this.toggleRecaptchaErr(true);
			this.toggleSubmitBtn(true);

			return;
		}

		const response:
			| IFormSubmitResponse
			| undefined = await CommunityCareService.sendForm(
			submissionEndpoint,
			dictionary,
			formDatasourceId,
			emailToSubmit
		);

		if (!response) {
			this.toggleSubmitBtn(true);
			throw new Error(
				`Error in retrieving response: ${JSON.stringify(response)}`
			);
		}

		if (response.isSuccessful()) {
			window.location.href = redirectSuccess;
		} else {
			window.location.href = redirectError;
		}
	}

	private toggleRecaptchaErr(toggleOn: boolean): void {
		const recaptchaField = this._element.querySelector(
			"[data-element='recaptchaField']"
		);

		if (!recaptchaField) {
			console.warn("No recaptcha field found. Check DOM.");

			return;
		}

		toggleOn
			? recaptchaField.classList.add("display")
			: recaptchaField.classList.remove("display");
	}

	private validate(): boolean {
		if (this._element) {
			return $(this._element).valid();
		}

		return false;
	}

	private toggleSubmitBtn(toggleOn: boolean): void {
		const submitBtn = this._element.querySelector("button[type='submit']");
		const disabledClass = "disabled";

		if (!submitBtn) {
			throw new Error(`Submit button not found for ${submitBtn}`);
		}

		toggleOn
			? submitBtn.classList.remove(disabledClass)
			: submitBtn.classList.add(disabledClass);
	}
}

ComponentFactory.registerComponent("communityCareForm", CommunityCareForm);
